import * as Types from '../../__generated__/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type NodeListQueryVariables = Types.Exact<{
  id?: Types.InputMaybe<Types.Scalars['String']>;
  nodeId?: Types.InputMaybe<Types.Scalars['String']>;
  pagination: Types.Pagination;
  filter: Array<Types.SearchFilter> | Types.SearchFilter;
  isInTranslation?: Types.InputMaybe<Types.Scalars['Boolean']>;
  withBreadcrumbs?: Types.InputMaybe<Types.Scalars['Boolean']>;
  withContents?: Types.InputMaybe<Types.Scalars['Boolean']>;
}>;


export type NodeListQuery = { nodeList: { enablePublish?: boolean | null, bulkPublish?: boolean | null, showPublishInfo?: boolean | null, nodes: { pageInfo: { hasNextPage: boolean }, edges: Array<{ cursor: string, node: { id: string, code: string, listName?: string | null, parent: string, parentCode: string, hierarchy: string, disabled: boolean, nodePublished: Types.CtgStatus, firstNodeStatus?: string | null, writeRoles?: Array<string> | null, writeUsers?: Array<string> | null, order?: string | null, createdAt: number, updatedAt: number, contentTypeGroupStatus?: Array<{ code: string, status: Types.CtgStatus, publishedAt?: string | null }> | null, breadcrumb?: Array<{ id: string, code: string, listName?: string | null }> | null, contents?: Array<{ contentTypeGroup: string, contentType: string, value?: Array<{ value: Array<any | null>, languageIsoCode: string }> | null }> } }> }, currentNode?: { code: string, hierarchy: string, id: string, listName?: string | null, parent: string, parentCode: string, nodePublished: Types.CtgStatus, readRoles?: Array<string> | null, writeRoles?: Array<string> | null, readUsers?: Array<string> | null, writeUsers?: Array<string> | null, createdAt: number, updatedAt: number, contentTypeGroupStatus?: Array<{ code: string, status: Types.CtgStatus, publishedAt?: string | null }> | null } | null }, breadcrumb: Array<{ id: string, code: string, listName?: string | null }> };

export type GetPublishedNodeVersionsQueryVariables = Types.Exact<{
  nodeIds: Array<Types.Scalars['String']> | Types.Scalars['String'];
  hierarchyId: Types.Scalars['String'];
}>;


export type GetPublishedNodeVersionsQuery = { getPublishedNodeVersions: Array<{ id: string, nodeId: string, version: number, parent: string, code: string, publishedAt: string, updatedBy: string, disabled: boolean, derivedFrom?: { version: number, publishedAt: string } | null }> };

export type GetPublishedContentQueryVariables = Types.Exact<{
  node: Types.Scalars['String'];
  hierarchy: Types.Scalars['String'];
  contentTypeGroup?: Types.InputMaybe<Types.Scalars['String']>;
  version?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type GetPublishedContentQuery = { getPublishedContent: { updatedAt: string, updatedBy: string, contentTypeGroups: Array<{ contentTypeGroup: string, contents: Array<{ contentTypeGroup: string, contentTypeGroupIndex: number, contentType: string, repeatable?: boolean | null, type: string, inherited: boolean, valueDecryptionFailed?: boolean | null, value?: Array<{ languageIsoCode: string, value: Array<any | null>, code?: string | null, measure?: string | null, translate?: boolean | null }> | null }> }> } };

export type GetHierarchyHistoryQueryVariables = Types.Exact<{
  hierarchy: Types.Scalars['String'];
  node: Types.Scalars['String'];
  pagination: Types.Pagination;
}>;


export type GetHierarchyHistoryQuery = { hierarchyHistory: { totalCount: number, pageInfo: { hasNextPage: boolean, endCursor?: string | null }, objectSchema: { contentTypeGroups?: Array<{ code: string, repeatable: boolean, name: Array<{ languageIsoCode: string, value: string }>, contentTypes?: Array<{ code: string, type: string, multiLanguage: boolean, multiValue: boolean, hierarchy?: string | null, hidden?: boolean | null, name: Array<{ languageIsoCode: string, value: string }>, optionalValues?: Array<{ code: string, value: Array<{ languageIsoCode: string, value: string }> }> | null, optionsSource?: { kind: string, contentTypeCode?: string | null } | null }> | null }> | null }, edges: Array<{ cursor: string, node: { eventId: string, user: string, eventName: string, source?: string | null, disabled: boolean, parent: string, code: string, timestamp: string, contents: Array<{ contentTypeGroup: string, contentType: string, repeatable?: boolean | null, type: string, inherited: boolean, value?: Array<{ languageIsoCode: string, value: Array<any | null>, code?: string | null, measure?: string | null }> | null }> } }> } };

export type PublishAllHierarchiesMutationVariables = Types.Exact<{
  hierarchies?: Types.InputMaybe<Array<Types.Scalars['String']> | Types.Scalars['String']>;
}>;


export type PublishAllHierarchiesMutation = { publishHierarchies?: { code: string, message: string } | null };

export type EventCreatedSubscriptionVariables = Types.Exact<{
  hierarchyId?: Types.InputMaybe<Types.Scalars['String']>;
  nodeId?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type EventCreatedSubscription = { eventCreated: { edits: Array<{ contentTypeGroupIndex: number, contentTypeGroup: string, contentType: string, value: any, type: string }> } };

export type JobFinishedSubscriptionVariables = Types.Exact<{
  company?: Types.InputMaybe<Types.Scalars['String']>;
  jobId?: Types.InputMaybe<Types.Scalars['String']>;
  username?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type JobFinishedSubscription = { jobFinished: { jobId?: string | null, filename?: string | null, type?: string | null, state?: string | null } };


export const NodeListDocument = gql`
    query NodeList($id: String, $nodeId: String, $pagination: Pagination!, $filter: [SearchFilter!]!, $isInTranslation: Boolean, $withBreadcrumbs: Boolean, $withContents: Boolean = false) {
  nodeList(
    id: $id
    nodeId: $nodeId
    pagination: $pagination
    filter: $filter
    isInTranslation: $isInTranslation
    withBreadcrumbs: $withBreadcrumbs
  ) {
    nodes {
      pageInfo {
        hasNextPage
      }
      edges {
        cursor
        node {
          id
          code
          listName
          parent
          parentCode
          hierarchy
          disabled
          nodePublished
          contentTypeGroupStatus {
            code
            status
            publishedAt
          }
          firstNodeStatus
          breadcrumb {
            id
            code
            listName
          }
          contents @include(if: $withContents) {
            contentTypeGroup
            contentType
            value {
              value
              languageIsoCode
            }
          }
          writeRoles
          writeUsers
          order
          createdAt
          updatedAt
        }
      }
    }
    currentNode {
      code
      hierarchy
      id
      listName
      parent
      parentCode
      nodePublished
      contentTypeGroupStatus {
        code
        status
        publishedAt
      }
      readRoles
      writeRoles
      readUsers
      writeUsers
      createdAt
      updatedAt
    }
    enablePublish
    bulkPublish
    showPublishInfo
  }
  breadcrumb(hierarchyId: $id, nodeId: $nodeId) {
    id
    code
    listName
  }
}
    `;

/**
 * __useNodeListQuery__
 *
 * To run a query within a React component, call `useNodeListQuery` and pass it any options that fit your needs.
 * When your component renders, `useNodeListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNodeListQuery({
 *   variables: {
 *      id: // value for 'id'
 *      nodeId: // value for 'nodeId'
 *      pagination: // value for 'pagination'
 *      filter: // value for 'filter'
 *      isInTranslation: // value for 'isInTranslation'
 *      withBreadcrumbs: // value for 'withBreadcrumbs'
 *      withContents: // value for 'withContents'
 *   },
 * });
 */
export function useNodeListQuery(baseOptions: Apollo.QueryHookOptions<NodeListQuery, NodeListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NodeListQuery, NodeListQueryVariables>(NodeListDocument, options);
      }
export function useNodeListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NodeListQuery, NodeListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NodeListQuery, NodeListQueryVariables>(NodeListDocument, options);
        }
export type NodeListQueryHookResult = ReturnType<typeof useNodeListQuery>;
export type NodeListLazyQueryHookResult = ReturnType<typeof useNodeListLazyQuery>;
export type NodeListQueryResult = Apollo.QueryResult<NodeListQuery, NodeListQueryVariables>;
export const GetPublishedNodeVersionsDocument = gql`
    query GetPublishedNodeVersions($nodeIds: [String!]!, $hierarchyId: String!) {
  getPublishedNodeVersions(nodeIds: $nodeIds, hierarchyId: $hierarchyId) {
    id
    nodeId
    version
    parent
    code
    publishedAt
    derivedFrom {
      version
      publishedAt
    }
    updatedBy
    disabled
  }
}
    `;

/**
 * __useGetPublishedNodeVersionsQuery__
 *
 * To run a query within a React component, call `useGetPublishedNodeVersionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublishedNodeVersionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublishedNodeVersionsQuery({
 *   variables: {
 *      nodeIds: // value for 'nodeIds'
 *      hierarchyId: // value for 'hierarchyId'
 *   },
 * });
 */
export function useGetPublishedNodeVersionsQuery(baseOptions: Apollo.QueryHookOptions<GetPublishedNodeVersionsQuery, GetPublishedNodeVersionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPublishedNodeVersionsQuery, GetPublishedNodeVersionsQueryVariables>(GetPublishedNodeVersionsDocument, options);
      }
export function useGetPublishedNodeVersionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPublishedNodeVersionsQuery, GetPublishedNodeVersionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPublishedNodeVersionsQuery, GetPublishedNodeVersionsQueryVariables>(GetPublishedNodeVersionsDocument, options);
        }
export type GetPublishedNodeVersionsQueryHookResult = ReturnType<typeof useGetPublishedNodeVersionsQuery>;
export type GetPublishedNodeVersionsLazyQueryHookResult = ReturnType<typeof useGetPublishedNodeVersionsLazyQuery>;
export type GetPublishedNodeVersionsQueryResult = Apollo.QueryResult<GetPublishedNodeVersionsQuery, GetPublishedNodeVersionsQueryVariables>;
export const GetPublishedContentDocument = gql`
    query GetPublishedContent($node: String!, $hierarchy: String!, $contentTypeGroup: String, $version: String) {
  getPublishedContent(
    node: $node
    hierarchy: $hierarchy
    contentTypeGroup: $contentTypeGroup
    version: $version
  ) {
    contentTypeGroups {
      contentTypeGroup
      contents {
        contentTypeGroup
        contentTypeGroupIndex
        contentType
        repeatable
        type
        inherited
        valueDecryptionFailed
        value {
          languageIsoCode
          value
          code
          measure
          translate
        }
      }
    }
    updatedAt
    updatedBy
  }
}
    `;

/**
 * __useGetPublishedContentQuery__
 *
 * To run a query within a React component, call `useGetPublishedContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublishedContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublishedContentQuery({
 *   variables: {
 *      node: // value for 'node'
 *      hierarchy: // value for 'hierarchy'
 *      contentTypeGroup: // value for 'contentTypeGroup'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useGetPublishedContentQuery(baseOptions: Apollo.QueryHookOptions<GetPublishedContentQuery, GetPublishedContentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPublishedContentQuery, GetPublishedContentQueryVariables>(GetPublishedContentDocument, options);
      }
export function useGetPublishedContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPublishedContentQuery, GetPublishedContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPublishedContentQuery, GetPublishedContentQueryVariables>(GetPublishedContentDocument, options);
        }
export type GetPublishedContentQueryHookResult = ReturnType<typeof useGetPublishedContentQuery>;
export type GetPublishedContentLazyQueryHookResult = ReturnType<typeof useGetPublishedContentLazyQuery>;
export type GetPublishedContentQueryResult = Apollo.QueryResult<GetPublishedContentQuery, GetPublishedContentQueryVariables>;
export const GetHierarchyHistoryDocument = gql`
    query GetHierarchyHistory($hierarchy: String!, $node: String!, $pagination: Pagination!) {
  hierarchyHistory(hierarchy: $hierarchy, node: $node, pagination: $pagination) {
    totalCount
    pageInfo {
      hasNextPage
      endCursor
    }
    objectSchema {
      contentTypeGroups {
        code
        repeatable
        name {
          languageIsoCode
          value
        }
        contentTypes {
          code
          type
          multiLanguage
          multiValue
          hierarchy
          hidden
          name {
            languageIsoCode
            value
          }
          optionalValues {
            code
            value {
              languageIsoCode
              value
            }
          }
          optionsSource {
            kind
            contentTypeCode
          }
        }
      }
    }
    edges {
      cursor
      node {
        eventId
        user
        eventName
        source
        disabled
        parent
        code
        timestamp
        contents {
          contentTypeGroup
          contentType
          repeatable
          type
          inherited
          value {
            languageIsoCode
            value
            code
            measure
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetHierarchyHistoryQuery__
 *
 * To run a query within a React component, call `useGetHierarchyHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHierarchyHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHierarchyHistoryQuery({
 *   variables: {
 *      hierarchy: // value for 'hierarchy'
 *      node: // value for 'node'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetHierarchyHistoryQuery(baseOptions: Apollo.QueryHookOptions<GetHierarchyHistoryQuery, GetHierarchyHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHierarchyHistoryQuery, GetHierarchyHistoryQueryVariables>(GetHierarchyHistoryDocument, options);
      }
export function useGetHierarchyHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHierarchyHistoryQuery, GetHierarchyHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHierarchyHistoryQuery, GetHierarchyHistoryQueryVariables>(GetHierarchyHistoryDocument, options);
        }
export type GetHierarchyHistoryQueryHookResult = ReturnType<typeof useGetHierarchyHistoryQuery>;
export type GetHierarchyHistoryLazyQueryHookResult = ReturnType<typeof useGetHierarchyHistoryLazyQuery>;
export type GetHierarchyHistoryQueryResult = Apollo.QueryResult<GetHierarchyHistoryQuery, GetHierarchyHistoryQueryVariables>;
export const PublishAllHierarchiesDocument = gql`
    mutation PublishAllHierarchies($hierarchies: [String!]) {
  publishHierarchies(hierarchies: $hierarchies) {
    code
    message
  }
}
    `;
export type PublishAllHierarchiesMutationFn = Apollo.MutationFunction<PublishAllHierarchiesMutation, PublishAllHierarchiesMutationVariables>;

/**
 * __usePublishAllHierarchiesMutation__
 *
 * To run a mutation, you first call `usePublishAllHierarchiesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishAllHierarchiesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishAllHierarchiesMutation, { data, loading, error }] = usePublishAllHierarchiesMutation({
 *   variables: {
 *      hierarchies: // value for 'hierarchies'
 *   },
 * });
 */
export function usePublishAllHierarchiesMutation(baseOptions?: Apollo.MutationHookOptions<PublishAllHierarchiesMutation, PublishAllHierarchiesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublishAllHierarchiesMutation, PublishAllHierarchiesMutationVariables>(PublishAllHierarchiesDocument, options);
      }
export type PublishAllHierarchiesMutationHookResult = ReturnType<typeof usePublishAllHierarchiesMutation>;
export type PublishAllHierarchiesMutationResult = Apollo.MutationResult<PublishAllHierarchiesMutation>;
export type PublishAllHierarchiesMutationOptions = Apollo.BaseMutationOptions<PublishAllHierarchiesMutation, PublishAllHierarchiesMutationVariables>;
export const EventCreatedDocument = gql`
    subscription EventCreated($hierarchyId: String, $nodeId: String) {
  eventCreated(hierarchyId: $hierarchyId, nodeId: $nodeId) {
    edits {
      contentTypeGroupIndex
      contentTypeGroup
      contentType
      value
      type
    }
  }
}
    `;

/**
 * __useEventCreatedSubscription__
 *
 * To run a query within a React component, call `useEventCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useEventCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventCreatedSubscription({
 *   variables: {
 *      hierarchyId: // value for 'hierarchyId'
 *      nodeId: // value for 'nodeId'
 *   },
 * });
 */
export function useEventCreatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<EventCreatedSubscription, EventCreatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<EventCreatedSubscription, EventCreatedSubscriptionVariables>(EventCreatedDocument, options);
      }
export type EventCreatedSubscriptionHookResult = ReturnType<typeof useEventCreatedSubscription>;
export type EventCreatedSubscriptionResult = Apollo.SubscriptionResult<EventCreatedSubscription>;
export const JobFinishedDocument = gql`
    subscription JobFinished($company: String, $jobId: String, $username: String) {
  jobFinished(company: $company, jobId: $jobId, username: $username) {
    jobId
    filename
    type
    state
  }
}
    `;

/**
 * __useJobFinishedSubscription__
 *
 * To run a query within a React component, call `useJobFinishedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useJobFinishedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobFinishedSubscription({
 *   variables: {
 *      company: // value for 'company'
 *      jobId: // value for 'jobId'
 *      username: // value for 'username'
 *   },
 * });
 */
export function useJobFinishedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<JobFinishedSubscription, JobFinishedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<JobFinishedSubscription, JobFinishedSubscriptionVariables>(JobFinishedDocument, options);
      }
export type JobFinishedSubscriptionHookResult = ReturnType<typeof useJobFinishedSubscription>;
export type JobFinishedSubscriptionResult = Apollo.SubscriptionResult<JobFinishedSubscription>;